import { useState, useRef, useEffect } from 'react';

export const useResendTimer = (initialTime = 60) => {
    const [resendTimer, setResendTimer] = useState(0);
    const intervalRef = useRef(null);

    const startResendTimer = () => {
        setResendTimer(initialTime);

        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        intervalRef.current = setInterval(() => {
            setResendTimer(prev => {
                if (prev <= 1) {
                    clearInterval(intervalRef.current);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const resetTimer = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
        setResendTimer(0);
    };

    useEffect(() => {
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    return { resendTimer, startResendTimer, resetTimer };
};